import axios from 'axios';
import Config from '../config/environments';
import validation from './validation';
import { checkIdle, updateLastAPICallTime } from '../service/user';

const baseURL = Config.END_POINT;

const baseRequest = {
  baseURL,
  withCredentials: false,
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
};

const axiosInstance = axios.create(baseRequest);
const axiosLogin = axios.create(baseRequest);

const checkingInterceptor = (config) => {
  checkIdle();
  updateLastAPICallTime();
  validation(config.response);
  return config;
};

axiosInstance.interceptors.response.use(validation, checkingInterceptor);
axiosLogin.interceptors.response.use(validation, validation);

export { axiosInstance, axiosLogin };
